module.exports = __webpack_public_path__ + "img/chevron-left-small-gray.8f153d4c.svg";